import * as React from 'react';
import { useState } from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { makeStyles } from '@material-ui/core/styles';
import ApplicationDetail from './applicationDetail';
import { PrintIcon } from '@egovernments/digit-ui-react-components';
import ReactToPrint from 'react-to-print';

const useStyles = makeStyles((theme) => ({
  customTab: {
    backgroundColor: '#1F4A7C',
    color: 'white',
    marginRight: '3px',
    borderRadius: '3px',
    '&.Mui-selected': {
      backgroundColor: 'transparent',
      color: 'black',
      border: `1px solid ${theme.palette.primary.main}`,
    },
    printerTab: {
      backgroundColor: '#1F4A7C',
      color: 'white',
      marginLeft: '200px',
      borderRadius: '2px',
    },
    printerIcon: {
      verticalAlign: 'middle',
      marginLeft: '5px',
    },
  },
}));

function InwardReport() {
  const classes = useStyles()
  const [selectedTabIndex, setSelectedTabIndex] = useState('1');
  const [value, setValue] = React.useState('1');
  const componentPDF = React.useRef();

  const handleChange = (newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%', typography: 'body1' }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', marginLeft: '20px' }}>
          <TabList onChange={handleChange} aria-label="lab API tabs example" defaultIndex={selectedTabIndex}>
            <Tab label="Inward Reports" value="1" className={classes.customTab} />
            <ReactToPrint
              trigger={() => <button style={{marginLeft: '50rem'}} id="invoice-print"><PrintIcon /></button>}
              content={() => componentPDF.current}
            />                  
          </TabList>
        </Box>
        <div ref={componentPDF}>
        <TabPanel value="1">
          <ApplicationDetail />
        </TabPanel>
        
        </div>
      
      </TabContext>
    </Box>
  );
}

export default InwardReport